

<ul class="nav grey lighten-4 py-4">
  <li class="nav-item">
    <a class="nav-link disabled" href="#!">Organización de Lenguajes y 
      Compiladores 2</a>
</li>

<li class="nav-item dropdown" dropdown  >
  <a dropdownToggle mdbWavesEffect type="button" class="nav-link dropdown-toggle waves-light" mdbWavesEffect>
    Ejecutar <span class="caret"></span></a>
  <div *dropdownMenu class="dropdown-menu dropdown dropdown-primary" role="menu">
    <a class="dropdown-item waves-light" mdbWavesEffect (click)="ejecutar()">Ejecutar Ascendente</a>
    <div class="divider dropdown-divider"></div>
    <a class="dropdown-item waves-light" mdbWavesEffect (click)="ejecutarDescendente()">Ejecutar Descendente</a>
    <div class="divider dropdown-divider"></div>
    <a class="dropdown-item waves-light" mdbWavesEffect (click)="traducir3D()">Traducir 3D XPAHT</a>
    <div class="divider dropdown-divider"></div>
    <a class="dropdown-item waves-light" mdbWavesEffect (click)="ejecutarXquery()">Ejecutar XQuery</a>
    <div class="divider dropdown-divider"></div>
    <a class="dropdown-item waves-light" mdbWavesEffect (click)="traducir3DXquery()">Traducir 3D XQuery</a>
  </div>
</li>
<li class="nav-item dropdown" dropdown  >
  <a dropdownToggle mdbWavesEffect type="button" class="nav-link dropdown-toggle waves-light" mdbWavesEffect>
    Arbol <span class="caret"></span></a>
  <div *dropdownMenu class="dropdown-menu dropdown dropdown-primary" role="menu">
    <a class="dropdown-item waves-light" mdbWavesEffect (click)="recorrer()">Arbol AST Ascendente XML</a>
    <div class="divider dropdown-divider"></div>
    <a class="dropdown-item waves-light" mdbWavesEffect (click)="ejecutarDescendente()">Arbol AST Descendente XML</a>
    <div class="divider dropdown-divider"></div>
    <a class="dropdown-item waves-light" mdbWavesEffect (click)="xprecorrerDes()">Arbol AST Descendente XPAHT</a>
  </div>
</li>

<li class="nav-item dropdown" dropdown  >
  <a dropdownToggle mdbWavesEffect type="button" class="nav-link dropdown-toggle waves-light" mdbWavesEffect>
    Reportes<span class="caret"></span></a>
  <div *dropdownMenu class="dropdown-menu dropdown dropdown-primary" role="menu">
    <a class="dropdown-item waves-light" mdbWavesEffect (click)="imprimirTabla()">Gramatical</a>
    <div class="divider dropdown-divider"></div>
    <a class="dropdown-item waves-light" mdbWavesEffect href="#">Errores léxico</a>
    <div class="divider dropdown-divider"></div>
    <a class="dropdown-item waves-light" mdbWavesEffect href="#">Errores sintáctico</a>
    <div class="divider dropdown-divider"></div>
    <a class="dropdown-item waves-light" (click)="openPage('TablaSim',2)"   mdbWavesEffect href="#">Errores el semántico</a>
    <div class="divider dropdown-divider"></div>
    </div>
</li>

<li class="nav-item">
<button mdbBtn   (click)="openPage('TablaSim',1)"  type="button" color="default" rounded="true" outline="true" mdbWavesEffect>Tabla de Símbolos</button>
</li>
<li class="nav-item">
  <button mdbBtn   (click)="optimizarCod()"  type="button" color="default" rounded="true" outline="true" mdbWavesEffect>Optimizar</button>
</li>
<li class="nav-item">
  <button mdbBtn   (click)="optimizarCodPasadas()"  type="button" color="default" rounded="true" outline="true" mdbWavesEffect>Optimizar Pasadas</button>
</li>
<li class="nav-item">
  <button mdbBtn   (click)="openPage('TablaSim',4)"  type="button" color="default" rounded="true" outline="true" mdbWavesEffect>Reporte Optimizacion</button>
</li>
</ul>
<br> 
<div class="container-fluid">
<mdb-card>
  
  <mdb-card-body>
    <mdb-card-title>
      <h5>XPAHT</h5>
    </mdb-card-title>
    <div class="col">
      <ngx-codemirror
      [(ngModel)]="entradaxpath"
      [options]="{
      lineNumbers: true,
      theme: 'material',
      mode: 'markdown'
      }"
    ></ngx-codemirror>
    </div>
  </mdb-card-body>
</mdb-card>
<br>
</div>
<div class="container-fluid">
<div class="row">
  <div class="col-sm-6 mb-3 mb-md-0">
    <mdb-card>
      <mdb-card-body>
        <mdb-card-title>
          <h5>XML</h5>
        </mdb-card-title>
        <div class="col">
          <ngx-codemirror
          [(ngModel)]="entradaxml"
          [options]="{
          lineNumbers: true,
          theme: 'material',
          mode: 'markdown'
          }"
        ></ngx-codemirror>
        </div>
      </mdb-card-body>
    </mdb-card>
  </div>
  <div class="col-sm-6">
    <mdb-card>
      <mdb-card-body>
        <mdb-card-title>
          <h5>Consola</h5>
        </mdb-card-title>
        <div class="col">
          <ngx-codemirror
          [(ngModel)]="consola"
          [options]="{
          lineNumbers: true,
          theme: 'material',
          mode: 'markdown'
          }"
        ></ngx-codemirror>
        </div>
      </mdb-card-body>
    </mdb-card>
  </div>
  <br>
  <div class="col-sm-6">
    <mdb-card>
      <mdb-card-body>
        <mdb-card-title>
          <h5>C3D optimizado en C</h5>
        </mdb-card-title>
        <div class="col">
          <ngx-codemirror
          [(ngModel)]="salidaC3Doptimizado"
          [options]="{
          lineNumbers: true,
          theme: 'material',
          mode: 'markdown'
          }"
        ></ngx-codemirror>
        </div>
      </mdb-card-body>
    </mdb-card>
  </div>
</div>

<br>
  <div id="TablaSim" class="tabcontent" style="background-color: #1b1d1c;">
    <table mdbTable id= "tablasimbols" style="width:100%" bordered="true">
    
    </table>
  </div>
</div>

<br>
  <div id="ast" class="tabcontent" style="background-color: #1b1d1c;">
    <div class="overflow-auto" id="graph" style="text-align: center;"></div>
  </div>

 

          
    <mdb-card>
      <mdb-card-body>
        <mdb-card-title>
          <h5>REPORTE GRAMATICAL</h5>
        </mdb-card-title>
        <div class="row">
          <div class="col-sm-6 mb-3 mb-md-0">
            <mdb-card-title>
              <h5>XML</h5>
            </mdb-card-title>
            <ngx-codemirror
            [(ngModel)]="reporteGramatical"
            [options]="{
            lineNumbers: true,
            theme: 'material',
            mode: 'markdown'
            }"
          ></ngx-codemirror>
          </div>
          <div class="col-sm-6">
            <mdb-card-title>
              <h5>XPATH</h5>
            </mdb-card-title>
            <ngx-codemirror
            [(ngModel)]="xpathRG"
            [options]="{
            lineNumbers: true,
            theme: 'material',
            mode: 'markdown'
            }"
          ></ngx-codemirror>
          </div>
        </div>
      </mdb-card-body>
    </mdb-card>
    <br>
    
      <mdb-card>
        
        <mdb-card-body>
          <mdb-card-title>
            <h5>Arbol</h5>
          </mdb-card-title>
          <div id="app"></div>
        </mdb-card-body>
      </mdb-card>
      <br>
    

    
<script type="text/javascript"></script>